var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38 13.718-13.661-1.175L19 0l-5.339 12.562L0 13.718l10.374 8.962L7.258 36 19 28.933 30.742 36l-3.097-13.32L38 13.718ZM19 25.39l-7.144 4.3 1.9-8.109-6.308-5.457 8.322-.72L19 7.768l3.249 7.655 8.322.72-6.308 5.457 1.9 8.11L19 25.39Z",
    fill: "#000"
  })));
};
export default SvgStarEmpty;